import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix } from '@antv/util';
import { group } from 'd3-array';
import { subObject } from '../utils/helper';
import { createDatumof, createValueof, mergeState, offsetTransform, renderBackground, renderLink, selectElementByData, selectG2Elements, selectPlotArea, useState } from './utils';
/**
 * highlight a group of elements.
 */
export function elementHighlight(root, _ref) {
  var elementsof = _ref.elements,
    datum = _ref.datum,
    _ref$groupKey = _ref.groupKey,
    groupKey = _ref$groupKey === void 0 ? function (d) {
      return d;
    } : _ref$groupKey,
    _ref$link = _ref.link,
    link = _ref$link === void 0 ? false : _ref$link,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? false : _ref$background,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 60 : _ref$delay,
    scale = _ref.scale,
    coordinate = _ref.coordinate,
    emitter = _ref.emitter,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? {} : _ref$state;
  var _a;
  var elements = elementsof(root);
  var elementSet = new Set(elements);
  var keyGroup = group(elements, groupKey);
  var valueof = createValueof(elements, datum);
  var _renderLink = renderLink(Object.assign({
      elements: elements,
      valueof: valueof,
      link: link,
      coordinate: coordinate
    }, subObject(state.active, 'link'))),
    _renderLink2 = _slicedToArray(_renderLink, 2),
    appendLink = _renderLink2[0],
    removeLink = _renderLink2[1];
  var _renderBackground = renderBackground(Object.assign({
      document: root.ownerDocument,
      scale: scale,
      coordinate: coordinate,
      background: background,
      valueof: valueof
    }, subObject(state.active, 'background'))),
    _renderBackground2 = _slicedToArray(_renderBackground, 3),
    appendBackground = _renderBackground2[0],
    removeBackground = _renderBackground2[1],
    isBackground = _renderBackground2[2];
  var elementStyle = deepMix(state, {
    active: Object.assign({}, ((_a = state.active) === null || _a === void 0 ? void 0 : _a.offset) && {
      //Apply translate to mock slice out.
      transform: function transform() {
        var _state$active;
        for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }
        var value = (_state$active = state.active).offset.apply(_state$active, params);
        var i = params[1];
        return offsetTransform(elements[i], value, coordinate);
      }
    })
  });
  var _useState = useState(elementStyle, valueof),
    setState = _useState.setState,
    removeState = _useState.removeState,
    hasState = _useState.hasState;
  var out; // Timer for delaying unhighlighted.
  var pointerover = function pointerover(event) {
    var element = event.target,
      _event$nativeEvent = event.nativeEvent,
      nativeEvent = _event$nativeEvent === void 0 ? true : _event$nativeEvent;
    if (!elementSet.has(element)) return;
    if (out) clearTimeout(out);
    var k = groupKey(element);
    var group = keyGroup.get(k);
    var groupSet = new Set(group);
    var _iterator = _createForOfIteratorHelper(elements),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var e = _step.value;
        if (groupSet.has(e)) {
          if (!hasState(e, 'active')) setState(e, 'active');
        } else {
          setState(e, 'inactive');
          removeLink(e);
        }
        if (e !== element) removeBackground(e);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    appendBackground(element);
    appendLink(group);
    // Emit events.
    if (!nativeEvent) return;
    emitter.emit('element:highlight', {
      nativeEvent: nativeEvent,
      data: {
        data: datum(element),
        group: group.map(datum)
      }
    });
  };
  var delayUnhighlighted = function delayUnhighlighted() {
    if (out) clearTimeout(out);
    out = setTimeout(function () {
      unhighlighted();
      out = null;
    }, delay);
  };
  var unhighlighted = function unhighlighted() {
    var nativeEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var _iterator2 = _createForOfIteratorHelper(elements),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var e = _step2.value;
        removeState(e, 'active', 'inactive');
        removeBackground(e);
        removeLink(e);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    if (nativeEvent) {
      emitter.emit('element:unhighlight', {
        nativeEvent: nativeEvent
      });
    }
  };
  var pointerout = function pointerout(event) {
    var element = event.target;
    if (background && !isBackground(element)) return;
    if (!background && !elementSet.has(element)) return;
    if (delay > 0) delayUnhighlighted();else unhighlighted();
  };
  var pointerleave = function pointerleave() {
    unhighlighted();
  };
  root.addEventListener('pointerover', pointerover);
  root.addEventListener('pointerout', pointerout);
  root.addEventListener('pointerleave', pointerleave);
  var onRest = function onRest(e) {
    var nativeEvent = e.nativeEvent;
    if (nativeEvent) return;
    unhighlighted(false);
  };
  var onHighlight = function onHighlight(e) {
    var nativeEvent = e.nativeEvent;
    if (nativeEvent) return;
    var data = e.data.data;
    var element = selectElementByData(elements, data, datum);
    if (!element) return;
    pointerover({
      target: element,
      nativeEvent: false
    });
  };
  emitter.on('element:highlight', onHighlight);
  emitter.on('element:unhighlight', onRest);
  return function () {
    root.removeEventListener('pointerover', pointerover);
    root.removeEventListener('pointerout', pointerout);
    root.removeEventListener('pointerleave', pointerleave);
    emitter.off('element:highlight', onHighlight);
    emitter.off('element:unhighlight', onRest);
    var _iterator3 = _createForOfIteratorHelper(elements),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var e = _step3.value;
        removeBackground(e);
        removeLink(e);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  };
}
export function ElementHighlight(_a) {
  var delay = _a.delay,
    createGroup = _a.createGroup,
    _a$background = _a.background,
    background = _a$background === void 0 ? false : _a$background,
    _a$link = _a.link,
    link = _a$link === void 0 ? false : _a$link,
    rest = __rest(_a, ["delay", "createGroup", "background", "link"]);
  return function (context, _, emitter) {
    var container = context.container,
      view = context.view,
      options = context.options;
    var scale = view.scale,
      coordinate = view.coordinate;
    var plotArea = selectPlotArea(container);
    return elementHighlight(plotArea, Object.assign({
      elements: selectG2Elements,
      datum: createDatumof(view),
      groupKey: createGroup ? createGroup(view) : undefined,
      coordinate: coordinate,
      scale: scale,
      state: mergeState(options, [['active', background ? {} : {
        lineWidth: '1',
        stroke: '#000'
      }], 'inactive']),
      background: background,
      link: link,
      delay: delay,
      emitter: emitter
    }, rest));
  };
}